export default "__VITE_ASSET__BteqyzYl__"